<template>
  <div>
    <NavigationBar
      showBackBtn
      titel="Dokumentvorlage bearbeiten"
    ></NavigationBar>
    <section>
      <template>
        <v-container fluid>
          <v-row class="match-height" v-if="template">
            <v-col cols="12">
              <v-card>
                <v-card-text>
                  <DocumentTemplateEditor
                    v-model="form"
                    :organizationId="$route.params.organizationId"
                    @valid="isFormValid = $event"
                  />
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                  <v-btn text @click="$router.go(-1)">
                    <v-icon left>mdi-close</v-icon>
                    Abbrechen
                  </v-btn>
                  <v-spacer></v-spacer>
                  <v-btn
                    depressed
                    color="success"
                    @click="saveTemplate"
                    :loading="loading"
                    :disabled="!isFormValid"
                  >
                    <v-icon left>mdi-content-save</v-icon>
                    Speichern
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-col>
          </v-row>

          <v-row v-else>
            <v-col cols="12">
              <v-skeleton-loader type="card"></v-skeleton-loader>
            </v-col>
          </v-row>
        </v-container>
      </template>
    </section>
  </div>
</template>

<script>
import NavigationBar from "@/components/_systemwide/NavigationBar.vue";
import DocumentTemplateEditor from "@/components/_systemwide/DocumentTemplateEditor.vue";
import { MY_ORGANIZATION } from "@/store/modules.js";
import {
  GET_DOCUMENT_TEMPLATES,
  UPDATE_DOCUMENT_TEMPLATE,
} from "@/store/action-types.js";

export default {
  name: "document-template-edit",
  components: {
    NavigationBar,
    DocumentTemplateEditor,
  },
  data() {
    return {
      loading: false,
      isFormValid: false,
      form: {
        name: "",
        description: "",
        category: null,
        placeholderContext: "member",
        usageContexts: [],
        usagePolicy: "noRestriction",
        dataMode: "single",
      },
    };
  },
  computed: {
    template() {
      return this.$store.state.myOrganization.documentTemplates.find(
        (t) => t.meta.id === this.$route.params.itemId,
      );
    },
  },
  watch: {
    template: {
      immediate: true,
      handler(val) {
        if (val) {
          this.form = {
            name: val.name || "",
            description: val.description || "",
            category: val.category || null,
            placeholderContext: val.placeholderContext || "member",
            usageContexts: val.usageContexts || [],
            usagePolicy: val.usagePolicy || "noRestriction",
            dataMode: val.dataMode || "single",
          };
        }
      },
    },
  },
  created() {
    this.initialize();
  },
  methods: {
    async initialize() {
      if (this.$store.state.myOrganization.documentTemplates.length === 0) {
        await this.$store.dispatch(
          `${MY_ORGANIZATION}${GET_DOCUMENT_TEMPLATES}`,
          {
            organizationId: this.$route.params.organizationId,
          },
        );
      }
    },
    async saveTemplate() {
      this.loading = true;
      try {
        await this.$store.dispatch(
          `${MY_ORGANIZATION}${UPDATE_DOCUMENT_TEMPLATE}`,
          {
            organizationId: this.$route.params.organizationId,
            itemId: this.$route.params.itemId,
            name: this.form.name,
            description: this.form.description,
            category: this.form.category,
            placeholderContext: this.form.placeholderContext,
            usageContexts: this.form.usageContexts,
            usagePolicy: this.form.usagePolicy,
            dataMode: this.form.dataMode,
          },
        );
        this.$router.push({
          name: "my-organization-document-templates-details",
          params: {
            organizationId: this.$route.params.organizationId,
            itemId: this.$route.params.itemId,
          },
        });
      } catch (error) {
        console.error("Error updating template:", error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
